module.exports = __webpack_public_path__ + "static/media/question3.af10b575.svg";